import {mountStudio} from './main';
import {Platform} from './Platform';
mountStudio(true,Platform);
